module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/onlinestore/bravestore_free_trial.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/onlinestore/bravestore_free_trial.png
// module id = QNi4
// module chunks = 0